export const reportHeaders = props=>props.reduce((o, {header, property})=>({
    ...o,
    [property]: header
}), {});
